/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjecttaskFromStandardtaskDto } from '../models/work-create-projecttask-from-standardtask-dto';
import { WorkCreateTaskDto } from '../models/work-create-task-dto';
import { WorkGetTasksByProjectIdsDto } from '../models/work-get-tasks-by-project-ids-dto';
import { WorkGetTasksForProjectIdsDto } from '../models/work-get-tasks-for-project-ids-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkTask } from '../models/work-task';
import { WorkUpdateTaskDto } from '../models/work-update-task-dto';
import { WorkUpdateTaskSortableRankDto } from '../models/work-update-task-sortable-rank-dto';

@Injectable({ providedIn: 'root' })
export class WorkTasksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tasksV2ControllerFindAllPaginated()` */
  static readonly TasksV2ControllerFindAllPaginatedPath = '/v2/tasks';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by standardtaskId query param.
     *           <p>
     *              <b>Format: </b> filter.standardtaskId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.standardtaskId=$not:$like:John Doe&filter.standardtaskId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.standardtaskId'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.mandatory=$not:$like:John Doe&filter.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.mandatory'?: Array<string>;

    /**
     * Filter by start query param.
     *           <p>
     *              <b>Format: </b> filter.start={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.start=$not:$like:John Doe&filter.start=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.start'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> start:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>start</li>
     * <li>end</li>
     * <li>status</li>
     * <li>team.name</li>
     * <li>due</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'status:ASC' | 'status:DESC' | 'team.name:ASC' | 'team.name:DESC' | 'due:ASC' | 'due:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'standardtaskId'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
'start'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.contactId', params['filter.contactId'], {});
      rb.query('filter.standardtaskId', params['filter.standardtaskId'], {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.mandatory', params['filter.mandatory'], {});
      rb.query('filter.start', params['filter.start'], {});
      rb.query('filter.end', params['filter.end'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'userId'?: (string | Array<string>);
        'contactId'?: (string | Array<string>);
        'standardtaskId'?: (string | Array<string>);
        'status'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'mandatory'?: (string | Array<string>);
        'start'?: (string | Array<string>);
        'end'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by standardtaskId query param.
     *           <p>
     *              <b>Format: </b> filter.standardtaskId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.standardtaskId=$not:$like:John Doe&filter.standardtaskId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.standardtaskId'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.mandatory=$not:$like:John Doe&filter.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.mandatory'?: Array<string>;

    /**
     * Filter by start query param.
     *           <p>
     *              <b>Format: </b> filter.start={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.start=$not:$like:John Doe&filter.start=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.start'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> start:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>start</li>
     * <li>end</li>
     * <li>status</li>
     * <li>team.name</li>
     * <li>due</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'status:ASC' | 'status:DESC' | 'team.name:ASC' | 'team.name:DESC' | 'due:ASC' | 'due:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'standardtaskId'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
'start'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}> {
    return this.tasksV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'standardtaskId'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
'start'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'standardtaskId'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
'start'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerCreate()` */
  static readonly TasksV2ControllerCreatePath = '/v2/tasks';

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerCreate$Response(
    params: {
      body: WorkCreateTaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerCreate(
    params: {
      body: WorkCreateTaskDto
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindUnassignedMandatoryPaginated()` */
  static readonly TasksV2ControllerFindUnassignedMandatoryPaginatedPath = '/v2/tasks/data-quality/unassigned-mandatory';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindUnassignedMandatoryPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindUnassignedMandatoryPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>due</li>
     * <li>name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'due:ASC' | 'due:DESC' | 'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,project.numberQualified,standardtask.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>project.numberQualified</li>
     * <li>standardtask.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindUnassignedMandatoryPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindUnassignedMandatoryPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindUnassignedMandatoryPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>due</li>
     * <li>name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'due:ASC' | 'due:DESC' | 'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,project.numberQualified,standardtask.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>project.numberQualified</li>
     * <li>standardtask.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.tasksV2ControllerFindUnassignedMandatoryPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindOneById()` */
  static readonly TasksV2ControllerFindOneByIdPath = '/v2/tasks/{id}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerDelete()` */
  static readonly TasksV2ControllerDeletePath = '/v2/tasks/{id}';

  /**
   * Required permissions: tasks:delete, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:delete, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerUpdate()` */
  static readonly TasksV2ControllerUpdatePath = '/v2/tasks/{id}';

  /**
   * Required permissions: tasks:update, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:update, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerCreateFromStandardTask()` */
  static readonly TasksV2ControllerCreateFromStandardTaskPath = '/v2/tasks/projecttaskFromStandardtask';

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerCreateFromStandardTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerCreateFromStandardTask$Response(
    params: {
      body: WorkCreateProjecttaskFromStandardtaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerCreateFromStandardTaskPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:create, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerCreateFromStandardTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerCreateFromStandardTask(
    params: {
      body: WorkCreateProjecttaskFromStandardtaskDto
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerCreateFromStandardTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerUpdateSortableRankForTaskGroup()` */
  static readonly TasksV2ControllerUpdateSortableRankForTaskGroupPath = '/v2/tasks/tasks/sortableRanks';

  /**
   * Required permissions: tasks:update, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerUpdateSortableRankForTaskGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerUpdateSortableRankForTaskGroup$Response(
    params: {
      body: Array<WorkUpdateTaskSortableRankDto>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerUpdateSortableRankForTaskGroupPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: tasks:update, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerUpdateSortableRankForTaskGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerUpdateSortableRankForTaskGroup(
    params: {
      body: Array<WorkUpdateTaskSortableRankDto>
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.tasksV2ControllerUpdateSortableRankForTaskGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated()` */
  static readonly TasksV2ControllerFindAllAppointmentTasksForProjectIdPaginatedPath = '/v2/tasks/appointments/forProjectId/{id}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> mandatory:DESC,sortableRank:DESC,start:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>start</li>
     * <li>end</li>
     * <li>status</li>
     * <li>team.name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'status:ASC' | 'status:DESC' | 'team.name:ASC' | 'team.name:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindAllAppointmentTasksForProjectIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> mandatory:DESC,sortableRank:DESC,start:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>start</li>
     * <li>end</li>
     * <li>status</li>
     * <li>team.name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'status:ASC' | 'status:DESC' | 'team.name:ASC' | 'team.name:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.tasksV2ControllerFindAllAppointmentTasksForProjectIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated()` */
  static readonly TasksV2ControllerFindAllAufgabenTasksForProjectIdPaginatedPath = '/v2/tasks/tasks/forProjectId/{id}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Filter by mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.mandatory=$not:$like:John Doe&filter.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.mandatory'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> mandatory:DESC,sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>user.lastName</li>
     * <li>due</li>
     * <li>start</li>
     * <li>end</li></ul>
     */
      sortBy?: Array<'user.lastName:ASC' | 'user.lastName:DESC' | 'due:ASC' | 'due:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindAllAufgabenTasksForProjectIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.end', params['filter.end'], {});
      rb.query('filter.mandatory', params['filter.mandatory'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'userId'?: (string | Array<string>);
        'end'?: (string | Array<string>);
        'mandatory'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Filter by mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.mandatory=$not:$like:John Doe&filter.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.mandatory'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> mandatory:DESC,sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>user.lastName</li>
     * <li>due</li>
     * <li>start</li>
     * <li>end</li></ul>
     */
      sortBy?: Array<'user.lastName:ASC' | 'user.lastName:DESC' | 'due:ASC' | 'due:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
};
};
}> {
    return this.tasksV2ControllerFindAllAufgabenTasksForProjectIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
'mandatory'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated()` */
  static readonly TasksV2ControllerFindAllAufgabenTasksForContactIdPaginatedPath = '/v2/tasks/tasks/forContactId/{id}';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> end:ASC,due:ASC,created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>user.lastName</li>
     * <li>due</li>
     * <li>start</li>
     * <li>end</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'user.lastName:ASC' | 'user.lastName:DESC' | 'due:ASC' | 'due:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'created:ASC' | 'created:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindAllAufgabenTasksForContactIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.end', params['filter.end'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'userId'?: (string | Array<string>);
        'end'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by end query param.
     *           <p>
     *              <b>Format: </b> filter.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.end=$not:$like:John Doe&filter.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.end'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> end:ASC,due:ASC,created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>user.lastName</li>
     * <li>due</li>
     * <li>start</li>
     * <li>end</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'user.lastName:ASC' | 'user.lastName:DESC' | 'due:ASC' | 'due:DESC' | 'start:ASC' | 'start:DESC' | 'end:ASC' | 'end:DESC' | 'created:ASC' | 'created:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}> {
    return this.tasksV2ControllerFindAllAufgabenTasksForContactIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'userId'?: (string | Array<string>);
'end'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindAllTasksForProjectsAndStandardtasks()` */
  static readonly TasksV2ControllerFindAllTasksForProjectsAndStandardtasksPath = '/v2/tasks/tasks/forProjectsAndStandardtasks';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindAllTasksForProjectsAndStandardtasks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerFindAllTasksForProjectsAndStandardtasks$Response(
    params: {
      body: WorkGetTasksByProjectIdsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindAllTasksForProjectsAndStandardtasksPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindAllTasksForProjectsAndStandardtasks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerFindAllTasksForProjectsAndStandardtasks(
    params: {
      body: WorkGetTasksByProjectIdsDto
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.tasksV2ControllerFindAllTasksForProjectsAndStandardtasks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerFindElektroinstallationTasksForProjects()` */
  static readonly TasksV2ControllerFindElektroinstallationTasksForProjectsPath = '/v2/tasks/tasks/elektroinstallationForProjects';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerFindElektroinstallationTasksForProjects()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerFindElektroinstallationTasksForProjects$Response(
    params: {
      body: WorkGetTasksForProjectIdsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerFindElektroinstallationTasksForProjectsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerFindElektroinstallationTasksForProjects$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tasksV2ControllerFindElektroinstallationTasksForProjects(
    params: {
      body: WorkGetTasksForProjectIdsDto
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.tasksV2ControllerFindElektroinstallationTasksForProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerSubscribe()` */
  static readonly TasksV2ControllerSubscribePath = '/v2/tasks/{id}/subscribers/me';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerSubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerSubscribe$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerSubscribePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerSubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerSubscribe(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerSubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerUnsubscribe()` */
  static readonly TasksV2ControllerUnsubscribePath = '/v2/tasks/{id}/subscribers/me';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerUnsubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerUnsubscribe$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerUnsubscribePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerUnsubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerUnsubscribe(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerUnsubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `tasksV2ControllerRemoveSubscriber()` */
  static readonly TasksV2ControllerRemoveSubscriberPath = '/v2/tasks/{id}/subscribers/{userId}';

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasksV2ControllerRemoveSubscriber()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerRemoveSubscriber$Response(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasksV2Service.TasksV2ControllerRemoveSubscriberPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasksV2ControllerRemoveSubscriber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasksV2ControllerRemoveSubscriber(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.tasksV2ControllerRemoveSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

}
